import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaGithub, FaTerminal, FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isCurrent = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-200/80 bg-[#FAF9F6]/90 backdrop-blur-md transition-colors">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-18">
          {/* Logo / Brand */}
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-slate-900 flex items-center justify-center text-white text-sm shadow-sm">
              <FaTerminal />
            </div>
            <span className="font-extrabold text-lg sm:text-xl tracking-tight text-slate-900">
              DevSponsor
            </span>
          </Link>

          {/* Navigation links */}
          <nav className="hidden md:flex items-center gap-2">
            <Link
              to="/"
              className={`px-3.5 py-2 rounded-xl text-sm font-semibold transition ${
                isCurrent('/')
                  ? 'text-slate-900 bg-white shadow-xs border border-slate-200/80'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/70'
              }`}
            >
              Gateways
            </Link>
            <Link
              to="/upi"
              className={`px-3.5 py-2 rounded-xl text-sm font-semibold transition ${
                isCurrent('/upi')
                  ? 'text-slate-900 bg-white shadow-xs border border-slate-200/80'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/70'
              }`}
            >
              UPI
            </Link>
            <Link
              to="/paypal"
              className={`px-3.5 py-2 rounded-xl text-sm font-semibold transition ${
                isCurrent('/paypal')
                  ? 'text-slate-900 bg-white shadow-xs border border-slate-200/80'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/70'
              }`}
            >
              PayPal
            </Link>
            <Link
              to="/crypto"
              className={`px-3.5 py-2 rounded-xl text-sm font-semibold transition ${
                isCurrent('/crypto')
                  ? 'text-slate-900 bg-white shadow-xs border border-slate-200/80'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100/70'
              }`}
            >
              Crypto
            </Link>
          </nav>

          {/* Action button */}
          <div className="hidden sm:flex items-center gap-3">
            <a
              href="https://github.com/sponsors/MrAbhi2k3"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold border border-slate-300 text-slate-800 bg-white hover:bg-slate-50 transition shadow-xs"
            >
              <FaGithub className="text-sm" />
              GitHub Sponsors
            </a>
          </div>

          {/* Mobile menu toggle */}
          <div className="flex md:hidden items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-xl text-slate-700 hover:text-slate-900 hover:bg-slate-100"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <FaTimes className="text-lg" /> : <FaBars className="text-lg" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-b border-slate-200 bg-[#FAF9F6] px-4 pt-2 pb-5 space-y-1.5">
          <Link
            to="/"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3.5 py-2 rounded-xl text-sm font-semibold text-slate-900 hover:bg-slate-100"
          >
            Gateways
          </Link>
          <Link
            to="/upi"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3.5 py-2 rounded-xl text-sm font-semibold text-slate-900 hover:bg-slate-100"
          >
            UPI
          </Link>
          <Link
            to="/paypal"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3.5 py-2 rounded-xl text-sm font-semibold text-slate-900 hover:bg-slate-100"
          >
            PayPal
          </Link>
          <Link
            to="/crypto"
            onClick={() => setMobileMenuOpen(false)}
            className="block px-3.5 py-2 rounded-xl text-sm font-semibold text-slate-900 hover:bg-slate-100"
          >
            Crypto
          </Link>
          <div className="pt-2">
            <a
              href="https://github.com/sponsors/MrAbhi2k3"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-xl text-xs font-bold border border-slate-300 text-slate-800 bg-white"
            >
              <FaGithub /> GitHub Sponsors
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
